// extracted by mini-css-extract-plugin
export default {"container":"Card_container__6KOT1","images":"Card_images__xdSpV","fadeIn":"Card_fadeIn__L3qE3","fadeOut":"Card_fadeOut__bEm9v","square":"Card_square__XGCGo"};